import { ApplicationRef, Component, HostListener, NgZone } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './services/core/auth/auth.service';
import { environment } from '../environments/environment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CountryCodes } from './consts/countryCode';

declare const gtag: Function;

@HostListener('window:popstate', ['$event'])

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(
      public router:Router,
      public authService: AuthService,
      private matIconRegistry: MatIconRegistry,
      private domSanitizer: DomSanitizer,
      private appRef: ApplicationRef,
      private ngZone: NgZone,
  ) {
    // Register country icons
    this.registerCountryIcons();

    // After navigation, ensure the full app tree runs change detection once.
    // Fixes first-paint gaps where lazy routes + async data left content blank until a second interaction.
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        queueMicrotask(() =>
          this.ngZone.run(() => {
            try {
              this.appRef.tick();
            } catch {
              /* ignore re-entrancy */
            }
          }),
        );
      });

    if (environment.production) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        /** START : Code to Track Page View  */
         gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects
         })
        /** END */
      })
    }
  }

  private registerCountryIcons() {
    // Utiliser tous les codes de pays du fichier CountryCodes
    const countryCodes = Object.values(CountryCodes);

    // Register each country icon
    countryCodes.forEach(code => {
      this.matIconRegistry.addSvgIcon(
        code,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/svg-country-flags/svg/${code}.svg`)
      );

      // Also register with colon prefix for backward compatibility
      this.matIconRegistry.addSvgIcon(
        `:${code}`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/svg-country-flags/svg/${code}.svg`)
      );
    });
  }

  onPopState(event) {
    location.reload()
  }

  ngOnInit(){
  }
}
